import { postApi } from "@/axios/interceptors";
export default {
  send(data: any) {
    return postApi.post("/auth/send", data);
  },
  login(data: any) {
    return postApi.post("/auth/login", data);
  },
  logout() {
    return postApi.post("/auth/logout", {});
  },

  checkSession() {
    return postApi.post("/auth/checkSession", {});
  },
  login_test(data: any) {
    return postApi.post("/auth/login_test", data);
  },
  insertDistrictUser(data: any) {
    return postApi.post("/auth/insertDistrictUser", data);
  },

  smsAuth(data: any) {
    return postApi.post("/auth/smsAuth", data);
  },
};
